import {
	Box,
	Button,
	Dialog,
	DialogActions,
	InputLabel,
	MenuItem,
	Select,
	Stack,
	Table,
	TextField,
	Typography,
} from "@mui/material";
import {
	EditCompanyDetailsModalTypes,
	companyCommunicationAddressDetailColumns,
	companyRegistredAddressDetailColumns,
	labourTableColumns,
} from "data/supplierPageData";
import { useState } from "react";
import LabourDataTable from "../LabourDataTable/LabourDataTable";
import { stateList } from "data/stateMasterList";
import SyncIcon from "@mui/icons-material/Sync";

const EditAddressDetails = ({ addressData, setAddressData, modalOpen, setModalOpen, submitFunction }) => {
	const formStack = {
		width: { xs: "80%", sm: "40%", md: "30%" },
	};
	const [updatedDetails, setUpdatedDetails] = useState(addressData);
	const [officePincodeError, setOfficePinCodeError] = useState("");

	const handlePinCodeChange = (event, col) => {
		const value = event.target.value;
		let obj = {};
		obj[col] = value;
		setUpdatedDetails({ ...updatedDetails, ...obj });

		const isValidPinCode = /^\d{6}$/.test(value);
		if (!isValidPinCode) {
			setOfficePinCodeError("pincode must be 6 digits");
		} else {
			setOfficePinCodeError("");
		}
	};

	const handleCloseModal = () => {
		setUpdatedDetails(addressData);
		setModalOpen(false);
	};
	const addressColumns = { ...companyRegistredAddressDetailColumns, ...companyCommunicationAddressDetailColumns };

	const handleCopyClick = () => {
		let obj = updatedDetails;
		obj[companyCommunicationAddressDetailColumns.communication_office_address.key] =
			updatedDetails[companyRegistredAddressDetailColumns.registred_office_address.key];
		obj[companyCommunicationAddressDetailColumns.communication_office_city.key] =
			updatedDetails[companyRegistredAddressDetailColumns.registred_office_city.key];
		obj[companyCommunicationAddressDetailColumns.communication_office_pin_code.key] =
			updatedDetails[companyRegistredAddressDetailColumns.registred_office_pin_code.key];
		obj[companyCommunicationAddressDetailColumns.communication_office_state.key] =
			updatedDetails[companyRegistredAddressDetailColumns.registred_office_state.key];
		setUpdatedDetails({ ...obj });
	};
	const handleFormSubmit = (e) => {
		e.preventDefault();
		let obj = {};
		Object.keys(addressColumns).forEach((col) => (obj[col] = updatedDetails[col]));
		if (typeof submitFunction === "function") submitFunction(obj, setModalOpen);
	};
	return (
		<Dialog
			fullWidth
			maxWidth="md"
			open={modalOpen}
			onClose={handleCloseModal}
			component="form"
			onSubmit={handleFormSubmit}>
			<Box width="98%" p={2} boxSizing="border-box">
				{/* <Typography textAlign="center" variant="h6" p={2} width="100%">
					Edit Addresses
				</Typography> */}
				<Stack width="100%" justifyContent="space-between" flexWrap="wrap" rowGap={1}>
					<Stack direction="row" width="100%" justifyContent="space-between" flexWrap="wrap" rowGap={1}>
						<Typography textAlign="center" variant="h6" width="100%">
							Registered Address
						</Typography>
						<Stack sx={{ width: "100%" }} spacing={0}>
							<InputLabel>Office Address:</InputLabel>
							<TextField
								size="small"
								type="text"
								multiline
								rows={2}
								value={updatedDetails.registred_office_address}
								onChange={(e) =>
									setUpdatedDetails({ ...updatedDetails, registred_office_address: e.target.value })
								}
								placeholder="Enter Address"
								required
							/>
						</Stack>
						<Stack sx={formStack} spacing={0}>
							<InputLabel>Office City Name:</InputLabel>
							<TextField
								size="small"
								type="text"
								value={updatedDetails.registred_office_city}
								onChange={(e) =>
									setUpdatedDetails({ ...updatedDetails, registred_office_city: e.target.value })
								}
								placeholder="Enter city name"
								required
							/>
						</Stack>
						<Stack sx={formStack} spacing={0}>
							<InputLabel>Office State:</InputLabel>
							<Select
								value={updatedDetails.registred_office_state}
								onChange={(e) =>
									setUpdatedDetails({ ...updatedDetails, registred_office_state: e.target.value })
								}
								MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
								size="small"
								fullWidth
								required>
								<MenuItem value={"select"}>Select State</MenuItem>
								{stateList &&
									stateList.map((row) => (
										<MenuItem key={row.state} value={row.state}>
											{row.state}
										</MenuItem>
									))}

							</Select>
						</Stack>
						<Stack sx={formStack} spacing={0}>
							<InputLabel>Office Pincode:</InputLabel>
							<TextField
								size="small"
								type="text"
								value={updatedDetails.registred_office_pin_code}
								onChange={(e) => handlePinCodeChange(e, "registred_office_pin_code")}
								placeholder="Enter 6 digit pincode"
								required
							/>
							<span className="error">{officePincodeError}</span>
						</Stack>
					</Stack>
					<Box alignSelf="center" pt={2}>
						<Button startIcon={<SyncIcon sx={{ transform: "scale(1.3)" }} />} onClick={handleCopyClick}>
							Copy
						</Button>
					</Box>

					<Stack direction="row" width="100%" justifyContent="space-between" flexWrap="wrap" rowGap={1}>
						<Typography textAlign="center" variant="h6" pt={2} width="100%">
							Communication Address
						</Typography>
						<Stack sx={{ width: "100%" }} spacing={0}>
							<InputLabel>Office Address:</InputLabel>
							<TextField
								size="small"
								type="text"
								multiline
								rows={2}
								value={updatedDetails.communication_office_address}
								onChange={(e) =>
									setUpdatedDetails({
										...updatedDetails,
										communication_office_address: e.target.value,
									})
								}
								placeholder="Enter Address"
								required
							/>
						</Stack>
						<Stack sx={formStack} spacing={0}>
							<InputLabel>Office City Name:</InputLabel>
							<TextField
								size="small"
								type="text"
								value={updatedDetails.communication_office_city}
								onChange={(e) =>
									setUpdatedDetails({ ...updatedDetails, communication_office_city: e.target.value })
								}
								placeholder="Enter city name"
								required
							/>
						</Stack>
						<Stack sx={formStack} spacing={0}>
							<InputLabel>Office State:</InputLabel>
							<Select
								value={updatedDetails.communication_office_state}
								onChange={(e) =>
									setUpdatedDetails({ ...updatedDetails, communication_office_state: e.target.value })
								}
								MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
								size="small"
								fullWidth
								required>
								<MenuItem value={"select"}>Select State</MenuItem>
								{stateList &&
									stateList.map((row) => (
										<MenuItem key={row.state} value={row.state}>
											{row.state}
										</MenuItem>
									))}

							</Select>
						</Stack>
						<Stack sx={formStack} spacing={0}>
							<InputLabel>Office Pincode:</InputLabel>
							<TextField
								size="small"
								type="text"
								value={updatedDetails.communication_office_pin_code}
								onChange={(e) => handlePinCodeChange(e, "communication_office_pin_code")}
								placeholder="Enter 6 digit pincode"
								required
							/>
							<span className="error">{officePincodeError}</span>
						</Stack>
					</Stack>
				</Stack>
			</Box>
			<DialogActions>
				<Button variant="outlined" onClick={handleCloseModal}>
					Cancel
				</Button>
				<Button autoFocus variant="contained" sx={{ mr: 1 }} type="submit">
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default EditAddressDetails;
